import { render, staticRenderFns } from "./POSProducts.vue?vue&type=template&id=33a5b900&scoped=true"
import script from "./POSProducts.vue?vue&type=script&lang=js"
export * from "./POSProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a5b900",
  null
  
)

export default component.exports